export default __webpack_public_path__ + "static/105-min-min-0713381e27299a55006e713e1c2dc129.jpg";